import { FC, useEffect, useState } from 'react';
import { SettingIcon } from '@ubie/ubie-icons';
import styles from './DeveloperBanner.module.css';
import { FORM_URL_BASE } from '~/constants/issueReport';
import { useRouter } from 'next/router';
import { getOfroFlags } from '~/services/OfroFlagService';
import Link from 'next/link';

export const DeveloperBanner: FC = () => {
  const [isDeveloper, setIsDeveloper] = useState(false);
  const [isInternalPreview, setIsInternalPreview] = useState(false);
  useEffect(() => {
    setIsDeveloper(getOfroFlags().isDeveloper ?? false);
    setIsInternalPreview(getOfroFlags().isInternalPreview ?? false);
  }, []);

  const router = useRouter();
  const [reportFormUrl, setReportFormUrl] = useState('');
  useEffect(() => {
    const currentUrl = encodeURIComponent(`${location.protocol}//${location.host}${router.asPath}`);
    setReportFormUrl(`${FORM_URL_BASE}${currentUrl}`);
  }, [router.asPath]);

  return isDeveloper ? (
    <div className={styles.banner}>
      <div className={styles.bannerHeading}>
        <SettingIcon className={styles.settingIcon} />
        <span>{isInternalPreview ? '社内確認モード' : '開発者モード'}</span>
      </div>

      <ul className={styles.linkList}>
        <li className={styles.linkListItem}>
          <a href={reportFormUrl} target="_blank" rel="noopener">
            気になる報告
          </a>
        </li>
        <li className={styles.linkListItem}>
          <Link href={`${process.env.NEXT_PUBLIC_MEDICO_URL}/settings`}>設定</Link>
        </li>
      </ul>
    </div>
  ) : null;
};
